export default __webpack_public_path__ + "static/media/Screenshot1.5d7603f3.png";